import React from 'react';

const LogingLoader = () => {
    return (
        <div className='logingLoader'>
            <h2>Redirecting to Login...</h2>
        </div>
    )
}

export default LogingLoader;